import { Box, Flex, IconButton, Text, Tooltip } from '@chakra-ui/react';
import React from 'react';
import { FiDownload, FiFile, FiTrash2 } from 'react-icons/fi';

interface AttachmentPreviewProps {
  url: string;
  onRemove?: () => void;
  onDownload?: () => void;
  fileName?: string;
}

const AttachmentPreview: React.FC<AttachmentPreviewProps> = ({
  url,
  onRemove,
  onDownload,
  fileName,
}) => {
  const displayName = fileName || url.split('/').pop() || 'arquivo';
  const truncatedName =
    displayName.length > 20
      ? `${displayName.substring(0, 17)}...`
      : displayName;

  return (
    <Box
      borderWidth="1px"
      borderRadius="md"
      p={2}
      width="full"
      maxWidth="250px"
      bg="white"
    >
      <Flex alignItems="center" justifyContent="space-between">
        <Flex alignItems="center" flex={1}>
          <Box mr={2}>
            <FiFile size={24} />
          </Box>
          <Tooltip label={displayName} placement="top">
            <Text fontSize="sm" noOfLines={1}>
              {truncatedName}
            </Text>
          </Tooltip>
        </Flex>
        <Flex>
          {onDownload && (
            <IconButton
              aria-label="Download"
              icon={<FiDownload />}
              size="sm"
              variant="ghost"
              onClick={onDownload}
              mr={1}
            />
          )}
          {onRemove && (
            <IconButton
              aria-label="Remove"
              icon={<FiTrash2 />}
              size="sm"
              variant="ghost"
              colorScheme="red"
              onClick={onRemove}
            />
          )}
        </Flex>
      </Flex>
    </Box>
  );
};

export default AttachmentPreview;
